import { styled } from "@mui/material/styles";
import { Box } from "@mui/material";

export const OptionGroupRoot = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "flex-start",
  boxSizing: "border-box",
  width: "max-content",
}));
